import React from 'react'
import Navbar from '../navbar/Navbar'
import { Footer } from '../footer/footer'
import { Outlet } from 'react-router-dom'

export const MainLayout = () => {
  return (
  <>
  <Navbar/>
  <Outlet/>
  <Footer/>
  </>
  )
}
